import { GridColDef } from "@mui/x-data-grid-pro";
import ItemStatus from "../../../../../../common/components/item_status";
import { Button, IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";


type Props = {
    onActionEdit: (idContaPagar: number | null, openState: boolean) => void,
    onActionDelete: (idContaPagar: number | null, openState: boolean) => void,
    onActionCopy: (idContaPagar: number | null, openState: boolean) => void,
    onActionExportar: (idContaPagar: number) => void,
}

export const GenerateContasPagarListaColumns = ({
    onActionEdit,
    onActionDelete,
    onActionCopy,
    onActionExportar,

}: Props): GridColDef[] => {

    const computeItemStatusTitle = (status: number) => {
        switch (status) {
            case 0:
                return "EA"; // EM ABERTO
            case 1: // PAGO
                return "P";
            case 2: // OUTROS
                return "O";
            case 3: // ATRASADAS
                return "AT";
            default:
                return "?";
        }
    };

    const computeItemStatusColor = (status: number) => {
        switch (status) {
            case 0: // EM ABERTO
                return "gray"; // em aberto
            case 1: // PAGO
                return "green";
            case 2: // OUTROS
                return "yellow";
            case 3: // ATRASADA
                return "red";
            default:
                return "blue";
        }
    };

    const computeItemStatusDescription = (status: number) => {
        switch (status) {
            case 0: // EM ABERTO
                return "Conta em aberto";
            case 1: // PAGO
                return "Conta Paga";
            case 2: // OUTROS
                return "Outros";
            case 3: // EM ABERTO
                return "Conta atrasada";
            default:
                return "?";
        }
    };


    return [
        {
            field: "status",
            filterable: false,
            headerName: "Status",
            minWidth: 80,
            width: 80,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    <ItemStatus
                        size="autowidth"
                        title={computeItemStatusTitle(params.value)}
                        color={computeItemStatusColor(params.value)}
                        description={computeItemStatusDescription(params.value)} />
                </div>
            )
        },
        {
            field: "nrContasPagar",
            filterable: false,
            headerName: "N°",
            flex: 1,
            minWidth: 50,
            sortable: false,
        },
        {
            field: "nomeCentroCusto",
            filterable: false,
            headerName: "Centro Custo",
            flex: 1,
            minWidth: 230,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    {params.value}
                </div>
            )
        },
        {
            field: "titulo",
            filterable: false,
            headerName: "Título/Pedido",
            flex: 1,
            minWidth: 150,
            sortable: false,
        },
        {
            field: "nomeFornecedor",
            filterable: false,
            headerName: "Fornecedor/ Funcionário",
            flex: 1,
            minWidth: 150,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    {params.value}
                </div>
            )
        },
        {
            field: "nrOrdemCompra",
            filterable: false,
            headerName: "OC",
            flex: 1,
            minWidth: 60,
            sortable: false,
        },
        {
            field: "numeroParcela",
            filterable: false,
            headerName: "N° Parcela",
            minWidth: 80,
            width: 80,
            sortable: false,
            renderCell: (params) => {
                const tipoParcela = params.row['tipoParcela'] as string;
                const numeroParcela = params.row['numeroParcela'] as number;
                return (
                    <div className="w-full h-full flex justify-center items-center">
                        {tipoParcela === "E" ? (
                            <ItemStatus
                                size="autowidth"
                                title={"Entrada"}
                                color={"blue"}
                                description={"Entrada"}
                            />) : (
                            <span>{numeroParcela !== null && numeroParcela !== undefined ? String(numeroParcela) : ""}</span>
                        )}
                    </div>
                )
            },
        },
        {
            field: "nrMedicaoTerceirizacao",
            filterable: false,
            headerName: "N° Med",
            minWidth: 80,
            width: 80,
            sortable: false,
        },
        {
            field: "valorPagar",
            filterable: false,
            headerName: "Valor Pagar",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "dataPagar",
            filterable: false,
            headerName: "Data Pagar",
            minWidth: 100,
            width: 100,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "valorPago",
            filterable: false,
            headerName: "Valor Pago",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },

        {
            field: "dataPago",
            filterable: false,
            headerName: "Data Pago",
            minWidth: 100,
            width: 100,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "exportar",
            filterable: false,
            headerName: "Exportar",
            minWidth: 80,
            width: 80,
            sortable: false,
            valueGetter: (_, row) => row['idContasPagar'] as number,
            renderCell: ({ value }) => {
                return (
                    <Button
                        onMouseDown={() => onActionExportar(value)}
                        sx={{
                            fontSize: 11,
                            paddingX: '.4rem',
                            paddingY: 0,
                            background: '#e6e6e6',
                            borderLeft: '.2rem solid #45b6af',
                            borderRadius: 0,
                            color: 'black',
                            fontWeight: 'normal',
                        }}>
                        Exportar
                    </Button>
                );
            },
        },

        {
            field: 'idContasPagar',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 140,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-1">

                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionCopy(params.value, true)}>
                            <DynamicIcon nameIcon="ContentCopy" size={25} className="text-purple-500" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>
                    </div>
                );
            }
        }

    ];

}